import { Stack } from '@mui/material';

import { AddAutomationButton } from './components/AddAutomationButton';
import { AutomationListCTA } from './components/AutomationListCTA';
import { AutomationListProps } from '../types';
import { ATSAutomationListTestIds } from 'data-testids/ATS';

export const AutomationList: React.FC<AutomationListProps> = () => {
  return (
    <Stack direction="column" data-testid={ATSAutomationListTestIds.LIST_PANE}>
      <Stack alignItems="flex-start">
        <AddAutomationButton />
      </Stack>
      <AutomationListCTA />
    </Stack>
  );
};
